import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { ProvidersCacheService } from './shared/services/providers-cache.service';
import { AllProvidersCacheService } from './shared/services/all-providers-cache.service';
import { InsuranceCoverageService } from './shared/services/insurance-coverage.service';
import { AgeLimitsCacheService } from './shared/services/age-limits-cache.service';
import { HeardAboutUsOptionsService } from './shared/services/heard-about-us-options.service';
import { AppErrorHandlerService } from './shared/services/app-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes), provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch()),
    {
      provide: APP_INITIALIZER,
      useFactory: (providersCache: ProvidersCacheService) => () => {
        void providersCache.initialize(true);
      },
      deps: [ProvidersCacheService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (allProvidersCache: AllProvidersCacheService) => () => {
        void allProvidersCache.initialize();
      },
      deps: [AllProvidersCacheService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (insuranceCoverage: InsuranceCoverageService) => () => {
        void insuranceCoverage.prefetchCarrierProviders(true);
      },
      deps: [InsuranceCoverageService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (ageLimitsCache: AgeLimitsCacheService) => () => {
        if (typeof window === 'undefined') return;
        void ageLimitsCache.initialize(true);
      },
      deps: [AgeLimitsCacheService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (heardAboutUsOptions: HeardAboutUsOptionsService) => () => {
        if (typeof window === 'undefined') return;
        void heardAboutUsOptions.prefetch(true);
      },
      deps: [HeardAboutUsOptionsService],
      multi: true
    },
    { provide: ErrorHandler, useClass: AppErrorHandlerService }
  ]
};
